import script from "./RequestCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestCourse.vue?vue&type=script&setup=true&lang=js"

import "./RequestCourse.vue?vue&type=style&index=0&id=044bde40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-044bde40"]])

export default __exports__